import {
    isOutNet
} from "D:/workspace/all_web/src/_cmm/js/util";
window._mtac = {"autoReport":0};
(function () {
    var mta = document.createElement("script");
    mta.src = window.location.protocol+"//pingjs.qq.com/h5/stats.js?v2.0.4";
    mta.setAttribute("name", "MTAH5");
    mta.setAttribute("sid", "500718685");
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(mta, s);
})();

window.addEventListener("load", function () {
    statPage();
});

export function stat(){
    this.$root.$on("SwitchTo", statPage);
    this.$root.$on("P3SwitchTo", statPage);
    this.$root.$on("P4SwitchTo", statPage);
}

export function statPage() {
    if(isOutNet()){
        window.MtaH5.pgv();
    }
}